import { render } from "./IconMobile.vue?vue&type=template&id=5e8df791"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e8df791"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e8df791', __exports__)) {
    api.reload('5e8df791', __exports__)
  }
  
  module.hot.accept("./IconMobile.vue?vue&type=template&id=5e8df791", () => {
    api.rerender('5e8df791', render)
  })

}


export default __exports__